import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash'
import axios from 'axios'

Vue.use(Vuex);


export const store = new Vuex.Store({
  state: {
    products: [],
    product:{},
    sorted:[],
    productsInCart: [],
    featuredProducts:[],
    min: 1,
    max: 1,

    stock: 1,
    stockMax: 1,

    sliderFilter: [],
    available: true,
    filterCat: null,
    filterTag: null,
    idprod:null,
    categories: [],

    orderPrice:null,
    orderAvailable:null,
    orderQuantity: null,

    searchVisible:false,
    searchTerm:'',

    price:0,
    shipping:0,

    formato:{ style: 'currency', currency: 'USD' },
    dominio: process.env.NODE_ENV === 'production' 
      ? 'https://sistema.empaqueslupa.com' 
      : (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1'
          ? 'https://sistema.empaqueslupa.com'
          : 'http://127.0.0.1:8000'),
    directory:'shop2',
    configTienda: {
        modo_vista_producto: 'ambos',
        numero_whatsapp: ''
    }
  },

  mutations: {
    setUpConfig(state, config) {
      state.configTienda = Object.assign({}, state.configTienda, config);
    },
    increment(state) {
      state.count++
    },

    setUpProducts(state, products) {
      state.products = products
      state.sorted = products
      
      // Si ya hay una categoría seleccionada (ej. al recargar), aplicar el filtro de inmediato
      if (state.filterCat) {
        this.commit('updateFilterCat', state.filterCat);
      }
    },
   
    setUpCategories(state, categories) {
      state.categories = categories
    },
    setUpCart(state) {
      // Check if the ID exists
      if (Object.prototype.hasOwnProperty.call(localStorage, 'products')) {
        // Replace the state object with the stored item
        state.productsInCart = JSON.parse(localStorage.getItem('products'))
      }
    },

    updateProduct(state, value){
      state.product = state.products.filter((a) => a.id==value)
    },
    updateRanges(state, value) {
      state.sliderFilter = [value[0], value[1]]
    },
    updateStock(state, value) {
      state.stock = value
    },
    updateAvailable(state, value) {
      state.available = value
    },
    // updateFilterCat(state, value) {
    //   state.filterCat = value
    // },
    updateFilterCat(state, value) {
      state.filterCat = value
      let base = state.products.data || state.products;
      
      const getAllCatIds = (catId, categories) => {
          let ids = [catId];
          const findCat = (id, cats) => {
              for (let c of cats) {
                  if (c.id == id) return c;
                  if (c.sublevels && c.sublevels.length > 0) {
                      let found = findCat(id, c.sublevels);
                      if (found) return found;
                  }
              }
              return null;
          }
          let root = findCat(catId, categories);
          if (root) {
              const collectIds = (node) => {
                  if (node.sublevels) {
                      for (let child of node.sublevels) {
                          ids.push(child.id);
                          collectIds(child);
                      }
                  }
              }
              collectIds(root);
          }
          return ids;
      }

      if (state.filterCat) {
         let allowedCatIds = getAllCatIds(state.filterCat, state.categories);
         base = base.filter((a) => {
             if (a.categorias && a.categorias.length > 0) {
                 return a.categorias.some(cat => allowedCatIds.some(id => id == (cat.id || cat)));
             }
             return allowedCatIds.some((id) => id == a.idcategoria);
         })
      }
      if (state.filterTag) {
         base = base.filter((a) => a.etiquetas && a.etiquetas.toLowerCase().includes(state.filterTag.toLowerCase()))
      }
      state.sorted = base.filter((a) => a.imagenes.length>0)
    },
    updateFilterTag(state, value) {
      state.filterTag = value
      let base = state.products.data || state.products;
      
      const getAllCatIds = (catId, categories) => {
          let ids = [catId];
          const findCat = (id, cats) => {
              for (let c of cats) {
                  if (c.id == id) return c;
                  if (c.sublevels && c.sublevels.length > 0) {
                      let found = findCat(id, c.sublevels);
                      if (found) return found;
                  }
              }
              return null;
          }
          let root = findCat(catId, categories);
          if (root) {
              const collectIds = (node) => {
                  if (node.sublevels) {
                      for (let child of node.sublevels) {
                          ids.push(child.id);
                          collectIds(child);
                      }
                  }
              }
              collectIds(root);
          }
          return ids;
      }

      if (state.filterCat) {
         let allowedCatIds = getAllCatIds(state.filterCat, state.categories);
         base = base.filter((a) => {
             if (a.categorias && a.categorias.length > 0) {
                 return a.categorias.some(cat => allowedCatIds.some(id => id == (cat.id || cat)));
             }
             return allowedCatIds.some((id) => id == a.idcategoria);
         })
      }
      if (state.filterTag) {
         base = base.filter((a) => a.etiquetas && a.etiquetas.toLowerCase().includes(state.filterTag.toLowerCase()))
      }
      state.sorted = base.filter((a) => a.imagenes.length>0)
    },
    
    updateorderAvaliable(state,value) {
      if(state.available) return
      state.orderAvailable = value

      state.sorted = _.orderBy(state.products,'available',value ? 'desc' : 'asc')

      state.orderQuantity = null // desactivar otros ordenados
      state.orderPrice = null
    },
    updateorderPrice(state,value) {
      state.orderPrice = value
      state.sorted = state.products.filter((a) => a.imagen!='noimagen')
      state.sorted = _.orderBy(state.sorted,'precio_venta',value ? 'desc' : 'asc')

      state.orderQuantity = null
      state.orderAvailable = null
    },
    updateorderQuantity(state,value) {
      state.orderQuantity = value

      state.sorted = _.orderBy(state.products,'stock',value ? 'desc' : 'asc')

      state.orderAvailable = null
      state.orderPrice = null
    },
    showSearch(state) {
      state.searchVisible = true
    },
    hideSearch(state) {
      state.searchVisible = false
    },
    search(state,value){
      state.sorted = state.products.filter((a) => {
        return a.name.includes(value)
        // return a.name.includes(value) && a.sublevel_id == state.filterCat // si se quisiera filtrar solo en la categoria activa
      })
    },


    saveToCart(state, payload, wanted = 1) {
      let productToAdd = payload;
      let qty = wanted;

      if (payload && payload.product) {
        productToAdd = payload.product;
        qty = payload.quantity || payload.product.cantidad || wanted;
      } else if (payload && payload.cantidad) {
        qty = payload.cantidad;
      }

      qty = parseInt(qty) || 1;

      // Unique identifier for items with distinct specifications
      let key = productToAdd.cartItemId || (productToAdd.id + '_' + (productToAdd.specs ? JSON.stringify(productToAdd.specs) : ''));
      productToAdd.cartItemId = key;

      let existing = state.productsInCart.find(a => (a.cartItemId || a.id) === key);

      if (existing) {
        existing.wanted = (parseInt(existing.wanted) || 0) + qty;
        existing.cantidad = existing.wanted;
        if (productToAdd.valor_total) {
          existing.valor_total = productToAdd.valor_total;
        }
      } else {
        productToAdd.wanted = qty;
        productToAdd.cantidad = qty;
        state.productsInCart.push(productToAdd);
      }
      this.commit('saveToLocalStorage');
    },
    removeFromCart(state, value) {
      let targetKey = value.cartItemId || value.id;
      state.productsInCart = state.productsInCart.filter((a) => {
        let itemKey = a.cartItemId || a.id;
        return itemKey !== targetKey;
      });

      this.commit('saveToLocalStorage');
    },
    changeQuantity(state, payload) {
      let targetItem = payload.product || payload;
      let newQty = payload.quantity !== undefined ? payload.quantity : (targetItem.wanted || targetItem.cantidad || 1);
      let targetKey = targetItem.cartItemId || targetItem.id;

      if (newQty < 1) return;

      let item = state.productsInCart.find(a => (a.cartItemId || a.id) === targetKey);
      if (item) {
        item.wanted = newQty;
        item.cantidad = newQty;
        if (item.valor_unitario) {
          item.valor_total = item.valor_unitario * newQty;
        }
      }

      this.commit('saveToLocalStorage');
    },
    updatePrice(state,value) {
      state.price = value[0]
      state.shipping = value[1]
    },
    purchase(state) {
      state.productsInCart = []
      this.commit('saveToLocalStorage')
    },
    saveToLocalStorage(state) {
      localStorage.setItem('products', JSON.stringify(state.productsInCart));
    }


  },

  getters: {
    products: state => state.products,
    cart: state => state.cart,
    product:state=>state.product,
    categorias:state=>state.categories,
  },

  actions: {
    getProductosCat(context, id){
      context.commit('updateFilterCat', id)
    },
    setUpStore(context) {
      var url= context.state.dominio + '/api/articulo';
      axios.get(url).then(function (response) {
        var respuesta= response.data.articulos;
          context.commit('setUpProducts', respuesta)
          
      })
      
      var url2= context.state.dominio + '/api/categoria';
      axios.get(url2).then(function (response) {
          var respuesta= response.data;
          return context.commit('setUpCategories', respuesta)
      })

      var urlConfig = context.state.dominio + '/api/tienda/configuracion';
      axios.get(urlConfig).then(function (response) {
          context.commit('setUpConfig', response.data);
      }).catch(function(err) {
          console.log('No se pudo cargar la configuracion de tienda:', err);
      });

      context.commit('setUpCart')
    },
   
    
  },

})
// store.subscribe((mutation, state) => {
//   // Store the state object as a JSON string
//   console.log(state,mutation)
//   localStorage.setItem('store', JSON.stringify(state));
// });